/*
 * @Author: 核酸检测结果查询相关路由
 * @Date: 2021-10-21 14:07:34
 * @LastEditTime: 2021-10-21 15:49:43
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 */

export default [
  {
    path: '/nucleicacidRecord/records',
    name: 'nucleicacidRecords',
    component: resolve => require(['@/views/nucleicacid-record/records'], resolve),
    meta: {
      title: '核酸检测结果查询'
    }
  },
  {
    path: '/nucleicacidRecord/recordDetail',
    name: 'nucleicacidRecordDetail',
    component: resolve => require(['@/views/nucleicacid-record/record-detail'], resolve),
    meta: {
      title: '核酸检测结果查询'
    }
  },
]



// WEBPACK FOOTER //
// ./src/router/modules/nucleicacid-record.js